import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import utc from 'dayjs/plugin/utc';

// Import locales with explicit references
import fr from 'dayjs/locale/fr';
import es from 'dayjs/locale/es';
import pt from 'dayjs/locale/pt';
import de from 'dayjs/locale/de';
import it from 'dayjs/locale/it';

// Extend dayjs with plugins
dayjs.extend(relativeTime);
dayjs.extend(localizedFormat);
dayjs.extend(utc);

// Register locales explicitly
const locales = { fr, es, pt, de, it };
Object.keys(locales).forEach(locale => {
  dayjs.locale(locale, locales[locale as keyof typeof locales]);
});

/**
 * Updates dayjs locale based on the current i18n language
 * @param locale - Language code from i18n
 */
export const updateDayjsLocale = (locale: string = 'en') => {
  try {
    if (dayjs.locale() !== locale) {
      dayjs.locale(locale);
    }
    return true;
  } catch (error) {
    console.warn(`Failed to set dayjs locale ${locale}, falling back to en`, error);
    dayjs.locale('en');
    return false;
  }
};

// Initialize with default locale
updateDayjsLocale('en');

export default dayjs;